import { ref, watch, isRef } from 'vue';
import nexceoProjectsAPI from 'dashboard/api/nexceo/projects';

// Module-level cache so hopping between standalone project tabs (Documents,
// Inventory, Knowledge, AI Employee) doesn't refetch the project header on
// every navigation — ProjectForm already holds the full record for the
// Details tab and never needs this.
const cache = new Map();

export function useProjectHeader(projectId) {
  const project = ref(null);
  const isLoading = ref(true);

  async function load(id) {
    if (!id) {
      project.value = null;
      isLoading.value = false;
      return;
    }
    if (cache.has(id)) {
      project.value = cache.get(id);
      isLoading.value = false;
      return;
    }
    isLoading.value = true;
    try {
      const { data } = await nexceoProjectsAPI.show(id);
      // my_role (M29.5.18) — the current user's tier on this specific
      // project (administrator/project_manager/project_executive), used to
      // decide whether Documents/Inventory show the full workspace tab bar
      // or just Documents+Inventory. See Nexceo::AccessPolicy#member_of_project?/#manages_project?.
      const summary = {
        name: data.name,
        status: data.status,
        my_role: data.my_role,
      };
      cache.set(id, summary);
      project.value = summary;
    } catch {
      // Non-fatal — the header simply falls back to its skeleton/placeholder.
    } finally {
      isLoading.value = false;
    }
  }

  if (isRef(projectId)) {
    watch(projectId, id => load(id), { immediate: true });
  } else {
    load(projectId);
  }

  return { project, isLoading };
}
